const defaultJson = {
  personal: [
    {
      name: "Demo User",
      email: "demouser@gmail.com",
      phone: "+91 XXXXXXXXXX",
      github: "github.com/XXXXXXXXXX",
      linkedin: "linkedin.com/in/XXXXXXXXXX",
      website: "LinkedInAutoApply.com",
    },
  ],
  summary: [
    {
      id: "summary-demo-1",
      summaryText:
        "A highly motivated and detail-oriented engineer with a Master's degree in Aerospace Engineering. Proficient in Python, AI, and full-stack development with a proven track record of developing and deploying scalable applications. Seeking to leverage analytical skills and hands-on experience to solve challenging problems in a dynamic environment.",
    },
  ],
  education: [
    {
      school: "Indian Institute of Technology, Kharagpur",
      degree: "Master of Technology in Aerospace Engineering",
      duration: "November 2020 - Present",
      location: "West Bengal, India",
      scoreType: "CGPA",
      gpa: "8.64/10",
    },
    {
      school: "Bharat National Public School",
      degree: "Class XII - Central Board of Secondary Education",
      duration: "May 2019",
      location: "Delhi, India",
      scoreType: "Percentage",
      gpa: "90%",
    },
  ],
  experience: [
    {
      title: "Full-Stack Founder & Developer",
      company: "LinkedInAutoApply.com",
      duration: "January 2024 - Present",
      location: "Remote",
      bullets: [
        "Engineered and launched LinkedInAutoApply.com, a full-stack platform using Node.js and React for automated job applications.",
        "Integrated a secure Razorpay payment gateway to efficiently manage user subscriptions and transactions.",
        "Architected a scalable backend with Firebase for robust data storage and real-time application updates.",
        "Leveraged Python and Generative AI for intelligent resume parsing and personalized application message generation.",
      ],
      tags: [
        "Node.js",
        "React",
        "Razorpay API",
        "Firebase",
        "Python",
        "Generative AI",
        "Full-Stack Development",
        "SaaS",
        "Automated Solutions",
      ],
    },
    {
      title: "Data Science Intern / AI Engineering Intern",
      company: "GradStem",
      duration: "May 2023 - June 2023",
      location: "Remote",
      bullets: [
        "Developed Python scripts for Indeed API integration, classifying thousands of job listings efficiently.",
        "Applied Artificial Intelligence techniques for precise technical and non-technical job classification.",
        "Utilized OpenAI GPT-4o API for resume personalization, improving Applicant Tracking System (ATS) compatibility.",
        "Automated job applications on Greenhouse/Workday using JavaScript, Selenium, Python, and Generative AI.",
      ],
      tags: [
        "Python",
        "Artificial Intelligence",
        "OpenAI GPT-4o",
        "ATS Optimization",
        "JavaScript",
        "Selenium",
        "Generative AI",
        "Data Science",
        "API Integration",
      ],
    },
    {
      title: "Deep Learning / Computer Vision Intern",
      company: "Artenal Robotics",
      duration: "May 2022 - August 2022",
      location: "Vancouver, Canada",
      bullets: [
        "Applied TensorFlow for object detection, recognition, and developing new orientation detection algorithms.",
        "Custom trained Convolutional Neural Network (CNN) models like YOLO v5/v6 using Python.",
        "Utilized advanced transfer learning techniques for enhanced AI software development and efficiency.",
        "Created an efficient image annotation app with Python's Tkinter library, streamlining project workflows.",
      ],
      tags: [
        "TensorFlow",
        "Object Detection",
        "Artificial Intelligence",
        "Python",
        "CNN",
        "YOLO",
        "Deep Learning",
        "Computer Vision",
        "Transfer Learning",
      ],
    },
  ],
  projects: [
    {
      title: "Nexus - Smart Scheduler (Voice Agent)",
      subtitle: "Self Project",
      duration: "July 2024",
      location: "Personal",
      bullets: [
        "Developed a conversational AI scheduling assistant with text and real-time voice modes, integrating Google Calendar.",
        "Implemented 'See, Then Act' logic ensuring no conflicting schedule suggestions for optimal planning.",
        "Utilized OpenAI Realtime API for low-latency, conversational voice interactions with server-side turn detection.",
        "Built with Node.js, Express.js, Vanilla HTML, CSS, JavaScript, and OpenAI Chat API (gpt-4.1-nano).",
      ],
      tags: [
        "Node.js",
        "Express.js",
        "JavaScript",
        "HTML",
        "CSS",
        "OpenAI API",
        "Google Calendar API",
        "Artificial Intelligence",
        "Generative AI",
        "Voice AI",
        "API Integration",
      ],
    },
    {
      title: "WhatsApp Automation Tool",
      subtitle: "Independent Software Development Project",
      duration: "January 2024 - Present",
      location: "Remote",
      bullets: [
        "Developed an Electron desktop app with `whatsapp-web.js` for end-to-end WhatsApp messaging automation.",
        "Implemented bulk messaging, auto-responders, contact scraping, and scheduling using JavaScript for lead outreach.",
        "Engineered CLI and REST API hooks for seamless integration into existing business workflows efficiently.",
        "Packaged the application with an auto-updating installer feature for enhanced user experience.",
      ],
      tags: [
        "Electron",
        "JavaScript",
        "Node.js",
        "Automation",
        "REST API",
        "Software Development",
        "CLI Tools",
      ],
    },
    {
      title: "Virtual AI Girlfriend",
      subtitle: "Self Project",
      duration: "July 2024",
      location: "Personal",
      bullets: [
        "Developed a web app (HTML, JS, CSS, Node.js) simulating interactive virtual partner conversations.",
        "Integrated Groq API with LLAMA 3 models for dynamic, context-aware conversational responses.",
        "Ensured multi-language support and created a visually appealing chat interface with customizable partner personalities.",
        "Conducted thorough unit testing for critical components of the Generative AI system.",
      ],
      tags: [
        "HTML",
        "JavaScript",
        "Node.js",
        "Generative AI",
        "Groq API",
        "LLAMA 3",
        "Artificial Intelligence",
        "Unit Testing",
        "Conversational AI",
      ],
    },
    {
      title: "Perplexity AI-Like System",
      subtitle: "Self Project",
      duration: "July 2024",
      location: "Personal",
      bullets: [
        "Developed a Python system where an LLM uses Google Search API to find and scrape web content.",
        "Utilized BeautifulSoup for efficient and precise web scraping and data extraction.",
        "Implemented Retrieval-Augmented Generation (RAG) for synthesizing scraped, up-to-date information.",
        "Utilized Groq API for faster LLM inference, significantly improving system performance and efficiency.",
      ],
      tags: [
        "Python",
        "LLM",
        "BeautifulSoup",
        "Artificial Intelligence",
        "RAG",
        "Generative AI",
        "Groq API",
        "Web Scraping",
        "Information Retrieval",
      ],
    },
    {
      title: "Aerial Image Segmentation with PyTorch",
      subtitle: "Self Project",
      duration: "July 2022",
      location: "Personal",
      bullets: [
        "Developed a custom Python dataset class, applying image-mask augmentation via Albumentations for road segmentation.",
        "Harnessed a pre-trained U-Net model from the PyTorch Segmentation Model library effectively.",
        "Streamlined model training with efficient training/evaluation functions in this software development initiative.",
        "Conducted comprehensive unit testing to ensure the reliability of segmentation model components.",
      ],
      tags: [
        "Python",
        "PyTorch",
        "U-Net",
        "Albumentations",
        "Unit Testing",
        "Deep Learning",
        "Image Segmentation",
        "Computer Vision",
      ],
    },
    {
      title: "Rock Paper Scissors Game",
      subtitle: "Self Project",
      duration: "May 2023 - June 2023",
      location: "Personal",
      bullets: [
        "Built a real-time 'Rock, Paper, Scissors' web app, training deep learning models using Python.",
        "Utilized webcam images with JavaScript and TensorFlow.js for real-time AI integration.",
        "Leveraged TensorFlow and transfer learning for user-driven model training with real-time predictions.",
        "Enabled model download for user convenience, extending utility of the trained deep learning model.",
      ],
      tags: [
        "Python",
        "JavaScript",
        "TensorFlow.js",
        "Deep Learning",
        "Artificial Intelligence",
        "Web Development",
        "Real-time Applications",
      ],
    },
    {
      title: "VTOL and Fixed Wing Hybrid Drone Design",
      subtitle: "Flight Testing Lab Project",
      duration: "August 2022 - November 2022",
      location: "IIT Kharagpur",
      bullets: [
        "Designed and simulated a hybrid VTOL and fixed-wing drone using MATLAB/SIMULINK and Simscape library.",
        "Conducted comprehensive analysis of drone’s flight characteristics and aerodynamic performance in OpenVSP.",
        "Designed and implemented PID control systems for transitions between hover and horizontal flight.",
      ],
      tags: [
        "MATLAB",
        "SIMULINK",
        "Simscape",
        "OpenVSP",
        "PID Control",
        "Aerospace Engineering",
        "Drone Design",
        "Simulation",
      ],
    },
  ],
  leadership: [
    {
      title: "Physics Olympiad Mentor",
      organization: "IIT Kharagpur (Extended Online)",
      duration: "August 2022 - Present",
      location: "IIT Kharagpur",
      bullets: [
        "Recorded and delivered comprehensive physics lectures to prepare students for national Physics Olympiads.",
        "Provided expert guidance and mentorship, improving understanding of complex physics concepts effectively.",
      ],
      tags: ["Mentorship", "Teaching", "Physics Education", "Academic Support"],
    },
    {
      title: "Football Team Player & Training Organizer",
      organization: "Inter IIT Sports Competition",
      duration: "November 2020 - May 2023",
      location: "IIT Kharagpur",
      bullets: [
        "Represented IIT Kharagpur as a football player in the prestigious Inter IIT sports competition.",
        "Organized and conducted rigorous training sessions for over 30 players, enhancing team skills.",
      ],
      tags: [
        "Leadership",
        "Teamwork",
        "Sports Coaching",
        "Event Organization",
        "Athletics",
      ],
    },
  ],
  skills: [
    {
      category: "Languages and Tools",
      skills: [
        "Python",
        "Java",
        "C/C++",
        "JavaScript",
        "Node.js",
        "Electron",
        "TensorFlow",
        "PyTorch",
        "Keras",
        "Scikit-learn",
        "OpenCV",
        "Pandas",
        "NumPy",
        "Matplotlib",
        "Seaborn",
        "SQL",
        "BeautifulSoup",
        "Selenium",
        "Firebase",
        "Razorpay API",
        "Groq API",
        "OpenAI API",
        "MATLAB",
        "SIMULINK",
        "Simscape",
        "OpenVSP",
        "Tkinter",
      ],
    },
    {
      category: "AI & Data Analysis",
      skills: [
        "Generative AI",
        "Artificial Intelligence",
        "Machine Learning",
        "Deep Learning",
        "Natural Language Processing (NLP)",
        "Data Visualization",
        "Web Scraping",
        "Retrieval-Augmented Generation (RAG)",
        "Transformers",
        "Computer Vision",
        "Object Detection",
        "Image Segmentation",
        "Transfer Learning",
        "Conversational AI",
      ],
    },
    {
      category: "Software Development Practices",
      skills: [
        "Software Development",
        "Unit Testing",
        "Code Reviews",
        "Documentation",
        "REST API Development",
        "Agile Methodologies",
        "Full-Stack Development",
        "System Design",
        "API Integration",
      ],
    },
  ],
};

export default defaultJson;
